import {gql} from '@apollo/client';
import {pwaClient} from './graphql_clients';
import {AppConfigQuery} from '../gql/pwa/graphql';
import {pwaRequestHeaders} from '../support/network.ts';

const LOCATION_FRAGMENT = gql`
    fragment LocationFragment on LocationType {
        id
        name
        email
        website
        phone_number
        whatsapp_number
        street
        house_number
        house_number_suffix
        postal_code
        city
        country
        photo_url
        coc_number
        tax_number
        email_extra {
            title
            value
            __typename
        }
        emergency_phone_extra {
            title
            value
            __typename
        }
        phone_extra {
            title
            value
            __typename
        }
        specialties {
            id
            name
            image_url
            activities {
                id
                name
                type
                __typename
            }
            replacement_vehicles {
                id
                name
                __typename
            }
            __typename
        }
        opening_hours {
            type
            opening_hours {
                start
                end
            }
            break_times {
                start
                end
            }
            __typename
        }
        __typename
    }
`;

const APP_CONFIG_QUERY = gql`
    query AppConfig {
        locations {
            ...LocationFragment
            __typename
        }
        appconfig {
            appid
            appname
            appicon
            color
            header_color
            header_text_color
            button_color
            button_text_color
            background_color
            background_text_color
            foreground_color
            border_color
            input_border_color
            firebase_api_key
            menu_extra {
                name
                url
                __typename
            }
            widget
            pwa_menu_2
            pwa_menu_3
            pwa_more_appointment
            pwa_more_occasions
            pwa_more_contact
            pwa_more_chat
            pwa_more_profile
            pwa_more_damage_report
            pwa_more_reviews
            splashscreen
            menuscreen
            loginscreen
            sliderphoto1
            sliderphoto2
            sliderphoto3
            google_analytics_code
            google_analytics_4_code
            facebook_id
            show_facebook_login
            google_id
            show_google_login
            __typename
        }
        organisation {
            name
            logo
            occasion_provider
            uses_v2
            email
            email_header_image
            email_footer_image
            email_button_color
            email_text_color
            whatsapp_number
            __typename
        }
        leadProviders {
            id
            name
            __typename
        }
    }

    ${LOCATION_FRAGMENT}
`;

export class AppConfig {
    static async appConfig() {
        const result = await pwaClient.query<AppConfigQuery>({
            query: APP_CONFIG_QUERY,
            context: {
                headers: pwaRequestHeaders,
            },
        });
        return result;
    }
}
